var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 2.3335H2.33366C2.02424 2.3335 1.72749 2.45641 1.5087 2.6752C1.28991 2.894 1.16699 3.19074 1.16699 3.50016V11.6668C1.16699 11.9762 1.28991 12.273 1.5087 12.4918C1.72749 12.7106 2.02424 12.8335 2.33366 12.8335H10.5003C10.8097 12.8335 11.1065 12.7106 11.3253 12.4918C11.5441 12.273 11.667 11.9762 11.667 11.6668V7.5835",
    stroke: "#325AE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.792 1.45838C11.0241 1.22632 11.3388 1.09595 11.667 1.09595C11.9952 1.09595 12.3099 1.22632 12.542 1.45838C12.7741 1.69045 12.9044 2.0052 12.9044 2.33338C12.9044 2.66157 12.7741 2.97632 12.542 3.20838L7.00032 8.75005L4.66699 9.33338L5.25033 7.00005L10.792 1.45838Z",
    stroke: "#325AE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.dd73c29e0982841b3e6a887dad739e59.svg";
export { ForwardRef as ReactComponent };